import React from "react";
import { Box, Dialog, DialogContent, DialogTitle } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CTLDialogContent from "application/components/styles/CTLDialogContent";

export default function CallListDialog({
  open,
  onClose,
  callList,
  darkMode,
  onJoin,
  onReject,
}) {
  return (
    <Dialog
      sx={(theme) => CTLDialogContent(theme, { darkMode })}
      open={open}
      onClose={onClose}
    >
      <DialogTitle sx={(theme) => CTLDialogContent(theme, { darkMode })}>
        Active Calls
      </DialogTitle>
      <DialogContent
        sx={(theme) => CTLDialogContent(theme, { darkMode })}
        pt={4}
      >
        {callList.length === 0 ? (
          <MDTypography sx={{ textAlign: "center", py: 3, color: "text" }}>
            No active calls
          </MDTypography>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {callList.map((call) => (
              <Box
                key={call.roomId}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 2,
                  gap: 2,
                  borderRadius: 2,
                  background: darkMode
                    ? "linear-gradient(135deg, rgba(66, 165, 245, 0.1) 0%, rgba(33, 150, 243, 0.05) 100%)"
                    : "linear-gradient(135deg, rgba(66, 165, 245, 0.08) 0%, rgba(33, 150, 243, 0.03) 100%)",
                  border: `1.5px solid ${
                    darkMode ? "rgba(66, 165, 245, 0.3)" : "rgba(66, 165, 245, 0.2)"
                  }`,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: darkMode
                      ? "linear-gradient(135deg, rgba(66, 165, 245, 0.15) 0%, rgba(33, 150, 243, 0.08) 100%)"
                      : "linear-gradient(135deg, rgba(66, 165, 245, 0.12) 0%, rgba(33, 150, 243, 0.06) 100%)",
                    border: `1.5px solid ${
                      darkMode
                        ? "rgba(66, 165, 245, 0.5)"
                        : "rgba(66, 165, 245, 0.4)"
                    }`,
                    boxShadow: "0 8px 24px rgba(66, 165, 245, 0.15)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      background: call.isSOS
                        ? "linear-gradient(135deg, #ff5252, #ff1744)"
                        : "linear-gradient(135deg, #2196F3, #1976D2)",
                      boxShadow: "0 4px 12px 0 rgba(0,0,0,0.15)",
                    }}
                  >
                    <MDTypography sx={{ fontSize: "20px", textAlign: "center" }}>
                      {call.isSOS ? "🚨" : call.isVideo ? "🎥" : "🔊"}
                    </MDTypography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.5,
                      minWidth: 0,
                    }}
                  >
                    <MDTypography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        fontSize: "13px",
                        color: call.isSOS ? "#ff1744" : "#2196F3",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {call.type} {call.isVideo ? "Video" : "Audio"}
                    </MDTypography>
                    <MDTypography
                      variant="body2"
                      sx={{
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "text",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {call.sender}
                    </MDTypography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                  <MDButton
                    color="success"
                    variant="contained"
                    size="small"
                    sx={{
                      fontSize: "11px",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      px: 2,
                      py: 0.8,
                      borderRadius: 1,
                      transition: "all 0.2s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                        boxShadow: "0 6px 16px rgba(76, 175, 80, 0.3)",
                      },
                    }}
                    onClick={() => onJoin(call)}
                  >
                    Join
                  </MDButton>
                  <MDButton
                    color="error"
                    variant="contained"
                    size="small"
                    sx={{
                      fontSize: "11px",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      px: 2,
                      py: 0.8,
                      borderRadius: 1,
                      transition: "all 0.2s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                        boxShadow: "0 6px 16px rgba(244, 67, 54, 0.3)",
                      },
                    }}
                    onClick={() => onReject(call)}
                  >
                    Reject
                  </MDButton>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
